import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import admin from './modules/admin';
import general from './modules/general';
import auth from './modules/auth';
import content from './modules/content';

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    admin,
    general,
    user,
    content
  },
  strict: debug,
  plugins: [createPersistedState()]
});
